module.exports = "img/flags/WS.bf46e06.png";